import { Channel } from 'core/models/channel';
import { LatencyData } from 'core/models/latency';

export class LatencyMeasure {
    private readonly history: LatencyData[] = [];
    private _tag: string;
    private _channel: Channel;

    constructor(tag: string, channel: Channel) {
        this._tag = tag;
        this._channel = channel;
    }

    private sum(arr: number[]) {
        return arr.reduce(function (prev, current) {
            return prev + current;
        });
    }

    private avg(data: number[]) {
        if (data.length == 0) return 0;
        const avg = Math.floor(this.sum(data) / data.length);
        return isNaN(avg) ? 0 : avg;
    }

    private push(data: (LatencyData | undefined)) {
        if (data) {
            this.history.push(data);
        }
    }

    get tag() {
        return this._tag;
    }

    update() {
        this.push(this._channel.getLatency());
    }

    reset() {
        this.history.length = 0;
    }

    get lastMeasurements() { return this.history.length > 0 ? this.history[this.history.length - 1] : undefined; }

    get averageMeasurements(): LatencyData {
        const averageData = {
            totalLatency: this.avg(this.history.map(x => x.totalLatency)),
            upstreamLatency: this.avg(this.history.map(x => x.upstreamLatency)),
            downstreamLatency: this.avg(this.history.map(x => x.downstreamLatency)),
            encodeTime: this.avg(this.history.map(x => x.encodeTime))
        };
        this.reset();
        return averageData;
    }
}
